import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import { CARD_BRANDS } from './cardConstants';

const CardBrandSelector = ({ selectedFlag, onSelectBrand, error }) => {
  return (
    <>
      <Typography variant="body2" fontWeight="bold" gutterBottom>
        BANDEIRA DO CARTÃO:
      </Typography>
      <Box display="flex" flexWrap="wrap" gap={2} mt={1}>
        {CARD_BRANDS.map((brand) => (
          <Button
            key={brand.nome}
            variant="outlined"
            onClick={() => onSelectBrand(brand.nome)}
            sx={{
              minWidth: '60px',
              height: '50px',
              backgroundColor: 'white',
              borderColor: selectedFlag === brand.nome ? '#6B46C1' : '#e0e0e0',
              borderWidth: selectedFlag === brand.nome ? '2px' : '1px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative',
              '&:hover': {
                backgroundColor: '#f5f5f5',
                borderColor: '#6B46C1'
              }
            }}
          >
            <img 
              src={brand.icon} 
              alt={brand.nome}
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain'
              }}
            />
            {selectedFlag === brand.nome && (
              <CheckCircle
                sx={{
                  position: 'absolute',
                  top: '-8px',
                  right: '-8px',
                  backgroundColor: '#6B46C1',
                  color: 'white',
                  borderRadius: '50%',
                  fontSize: '20px'
                }}
              />
            )}
          </Button>
        ))}
      </Box>
      {error && (
        <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block' }}>
          {error}
        </Typography>
      )}
    </>
  );
};

export default CardBrandSelector;